





















import { CreationLocalStorageKey, StorageStatus } from '@tt4b/ttam-enums';
import TipBox from '@/components/common/tip-box/index.vue';
import { ref } from 'vue-demi';

export default {
  name: 'BidCapUpgradeTips',
  components: {
    TipBox,
  },
  props: {
    isUpgradable: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const isHide = localStorage.getItem(CreationLocalStorageKey.BidCapToCostCap) === StorageStatus.Hide;
    const showTip = ref(!isHide);

    const onClose = () => {
      localStorage.setItem(CreationLocalStorageKey.BidCapToCostCap, StorageStatus.Hide);
      showTip.value = false;
    };

    return {
      showTip,
      onClose,
    };
  },
};
